<template>
    <!-- Add Task Modal -->
    <div class="modal fade" id="addTaskModal" ref="addTaskModal" tabindex="-1" aria-labelledby="taskModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 900px;">
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="taskModalLabel"><template v-if="task!=null">Edit</template><template v-else>Add</template> Task</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                </div>
                <div class="modal-body" v-if="form">
                    <div class="alert alert-success" role="alert" v-if="successMessage">
                        {{ successMessage }}
                    </div>

                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="javascript:void(0);" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation" name="addTask">
                        <form @submit.prevent="handleSubmit(submitHandler)" enctype="multipart/form-data">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Type</label>
                                        <template v-if="task && form.order_type">: {{form.order_type == 'so' ? 'Sales Order' : 'Purchase Order'}}</template>
                                        <template v-else>
                                            <ValidationProvider name="Order Type" rules="required" v-slot="{ errors }">
                                                <!--<input type="text" class="form-control" v-model="form.order_id" />-->
                                                <select class="form-control" v-model="form.order_type">
                                                    <option :value="null">Select</option>
                                                    <option value="so">Sales Order</option>
                                                    <option value="po">Purchase Order</option>
                                                </select>
                                                <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </template>

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Order Number</label>
                                        <template v-if="task && form.order">{{task.taskable.text}}</template>
                                        <template v-else>
                                            <ValidationProvider name="Order Number" rules="required" v-slot="{ errors }">
                                                <!--<input type="text" class="form-control" v-model="form.order_id" />-->
                                                <v-select label="text" :filterable="false"
                                                          v-model="form.order"
                                                          :options="orders"
                                                          @search="onOrderSearch"
                                                          @input="onOrderSelect"
                                                          @selected="onOrderSelect"
                                                          @deselected ="onOrderDeSelect">
                                                    <template slot="no-options">
                                                        type to search orders..
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center" v-html="option.text">
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center" v-html="option.text">
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                            </ValidationProvider>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-3">
                                        <label class="form-label">Title</label>
                                        <ValidationProvider name="Title" rules="required" v-slot="{ errors }">
                                            <input type="text" class="form-control" v-model="form.title" :readonly="task != null && form.title != null && workflows.filter((x) => x.name.trim().toLowerCase() === form.title.trim().toLowerCase()).length" />
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="task == null || (form.title != null && workflows.filter((x) => x.name.trim().toLowerCase() === form.title.trim().toLowerCase()).length === 0)">
                                <div class="col-md-12">
                                    <label class="form-label">Description</label>
                                    <textarea class="form-control" style="height: 80px" v-model="form.details"></textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Due Date</label>
                                        <ValidationProvider name="Due Date" rules="required" v-slot="{ errors }">
                                            <date-picker v-model="form.due_date" format="MM/DD/YYYY" valueType="format"></date-picker>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Assign To</label>
                                        <ValidationProvider name="Assign To" rules="required" v-slot="{ errors }">
                                            <!--<select class="form-control" v-model="form.assign_ids" multiple="" >
                                                <option :value="null">Select</option>
                                                <option v-for="(admin, index) in admins" :value="admin.id">
                                                    {{ admin.name }}
                                                </option>
                                            </select>-->
                                            <v-select label="name" :filterable="true" multiple=""
                                                      v-model="form.assign_admins"
                                                      :options="admins"
                                                      @input="onAdminSelect"
                                                      @selected="onAdminSelect"
                                                      @deselected ="onAdminDeSelect">
                                                <template slot="no-options">
                                                    type to search admins..
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center" v-html="option.name">
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center" v-html="option.name">
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-12" v-if="task == null || (form.title != null && workflows.filter((x) => x.name.trim().toLowerCase() === form.title.trim().toLowerCase()).length === 0)">
                                    <div class="mt-3">
                                        <label class="form-label">Upload</label>
                                        <vue-dropzone :options="dropzoneOptions"
                                                      :id="'item-dropzone-attach'"
                                                      v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                                        </vue-dropzone>
                                        <div>
                                            <template v-if="attached_file">
                                                <div class="pdf-dwn-sec line-hgt" :class="'vendor_num_1'">
                                                    <img v-if="attached_file.url && (attached_file.file_ext.toLowerCase() == 'png' || attached_file.file_ext.toLowerCase() == 'jpeg' || attached_file.file_ext.toLowerCase() == 'jpg')"
                                                         :src="attached_file.url" style="width:70px;height:70px">
                                                    {{attached_file.filename ? attached_file.filename : attached_file.attach_link}}
                                                    <a href="javascript:void(0)" class="trash_btn"
                                                       @click="deleteAttachFile()"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Priority</label>
                                        <select class="form-select" v-model="form.priority_id">
                                            <option :value="null">Select</option>
                                            <option v-for="(item, index) in priorities" :value="item.id">
                                                {{ item.priority_name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Status</label>
                                        <select :readonly="((getUser!= null && getUser.user_type == 1) || hasRole('Admin') && task != null)" class="form-select" v-model="form.status">
                                            <option value="0">Open</option>
                                            <option value="1">Completed</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6" v-if="task === null">
                                    <div class="mt-3">
                                        <label class="form-label">Artwork/Deposit/Sample Required?</label>
                                        <div class="form-group">
                                            <div class="form-check" v-if="form.order_type === 'so'">
                                                <input v-model="form.is_artwork_required" type="checkbox" class="form-check-input" />
                                                <label class="form-check-label">Is artwork required?</label>
                                            </div>
                                            <div class="form-check">
                                                <input v-model="form.is_deposit_required" type="checkbox" class="form-check-input" />
                                                <label class="form-check-label">Is deposit required?</label>
                                            </div>
                                            <div class="form-check" v-if="form.order_type === 'so'">
                                                <input v-model="form.is_sample_required" type="checkbox" class="form-check-input" />
                                                <label class="form-check-label">Is sample required?</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3 text-end">
                                <button type="submit" :disabled="loading" class="btn btn-primary fw-semibold fs-14 px-4">Save</button>
                            </div>
                        </form>
                    </ValidationObserver>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {ValidationProvider, ValidationObserver, extend, configure} from 'vee-validate';
import axios from "axios";
import DatePicker from "vue2-datepicker";
import {mapActions, mapGetters, mapState} from "vuex";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import {debounce} from 'lodash';

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
});

extend('positive', value => {
    if (value >= 0) {
        return true;
    }

    return 'This field must be a positive number';
});

export default {
    name: "AddTask",
    props:['task', 'loading', 'bus'],
    components:{
        ValidationObserver, ValidationProvider,
        vueDropzone: vue2Dropzone,
        DatePicker
    },
    created() {
    },
    mounted() {
        this.getTaskSettings();
        let self = this;
        if(this.bus) {
            this.bus.$on('triggerCompleteTask', (id) => {
                self.completeTask(id);
            });
        }

        $("#addTaskModal").on('show.bs.modal', () => {
            if(self.task) {
                if(self.task.taskable_type === 'App\\Models\\Order' && self.task.taskable) {
                    self.form.order_type = 'so';
                    self.task.taskable.text = '#' + self.task.taskable.order_number;
                    self.task.taskable.html = '#' + self.task.taskable.order_number;
                } else {
                    self.form.order_type = 'po';
                    self.task.taskable.text = '#' + self.task.taskable.po_number;
                    self.task.taskable.html = '#' + self.task.taskable.po_number;
                }

                self.form.order_id = self.task.taskable.id;
                self.form.order = self.task.taskable;

                self.form.title = self.task.title;
                self.form.details = self.task.details;
                self.form.due_date = self.task.due_date ? self.formatDate(self.task.due_date) : null;

                //self.form.assign_ids = self.task.assign_ids;
                self.form.assign_ids = [];
                self.form.assign_admins = [];
                if(self.task.admins) {
                    self.task.admins.forEach((x) => {
                        self.form.assign_ids.push(x.id);
                        self.form.assign_admins.push(x);
                    });
                }
                self.form.priority_id = self.task.priority_id;
                self.form.status = self.task.status;

                if(self.task.attachments && self.task.attachments.length) {
                    self.form.media_id = self.task.attachments[0].uploaded_media_id;

                    self.attached_file = self.task.attachments[0];
                }
            }
        });

        $('#addTaskModal').on('hidden.bs.modal', function () {
            self.form = {
                order: null,
                order_id: null,
                order_type: 'so',
                title: null,
                details: null,
                due_date: null,
                assign_ids: [],
                assign_admins: [],
                priority_id: null,
                status: 0,
                media_id: null,
                is_artwork_required: 0,
                is_deposit_required: 0,
                is_sample_required: 0,
                is_no_artwork: 0,
                is_repeat_order: 0,
            };

            self.attached_file = null;
            self.$refs.formValidation.reset();
        });
    },
    data(){
        return {
            form: {
                order: null,
                order_id: null,
                order_type: 'so',
                title: null,
                details: null,
                due_date: null,
                assign_ids: [],
                assign_admins: [],
                priority_id: null,
                status: 0,
                media_id: null,
                is_artwork_required: 0,
                is_deposit_required: 0,
                is_sample_required: 0,
                is_no_artwork: 0,
                is_repeat_order: 0,
            },
            admins: [],
            priorities: [],
            workflows: [],
            orders: [],
            dropzoneOptions: {
                url: window.route('medias.store'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 1,
                addRemoveLinks: false,
                chunking: false,
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
            attached_file: null
        };
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        completeTask(id) {
            let self = this;
            return axios.put(window.route('dashboard.tasks.complete', {id: id}), {},{

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && Object.keys(data.errors).length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSuccessMessage(data.data);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        self.$emit('completedEvent', data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        submitHandler() {
            this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }

                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);

                if(this.task) {
                    return axios.put(window.route('dashboard.tasks.update', {id: this.task.id}), this.form,{

                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        }
                    })
                        .then(({data}) => {
                            if (data.errors && Object.keys(data.errors).length) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage(data.data);
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit('updatedEvent', data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                        })
                        .finally(() => {
                            self.setLoading(false);

                        });
                } else {
                    return axios.post(window.route('dashboard.tasks.store'), this.form,{

                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        }
                    })
                        .then(({data}) => {
                            if (data.errors && Object.keys(data.errors).length) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage(data.data);
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit('addedEvent', data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                        })
                        .finally(() => {
                            self.setLoading(false);

                        });
                }
            });
        },
        getTaskSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.get(window.route('dashboard.tasks.settings'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.admins = _.cloneDeep(data.data.admins);
                        this.priorities = _.cloneDeep(data.data.priorities);
                        this.workflows = _.cloneDeep(data.data.workflows);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        afterUploadComplete(file, response) {
            this.form.media_id = response.data.media.id;
            let media = _.cloneDeep(response.data.media);
            media['url'] = response.data.url;
            this.attached_file = _.cloneDeep(media);
        },
        deleteAttachFile() {
            this.form.media_id = null;
            this.attached_file = null;
        },
        onAdminSelect(event){
            if (event) {

            } else {

            }
        },
        onAdminDeSelect(event){

        },
        onOrderSelect(event){
            if (event) {
                this.form.order_id = event.id;
            } else {
                this.form.order_id = null;
            }
        },
        onOrderDeSelect(event){
            this.form.order_id = null;
        },
        onOrderSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.searchOrder(loading, search, this);
            }
        },
        searchOrder: debounce((loading, search, vm) => {
            let url = window.route('orders.search', {searchTerm: search});
            if(vm.form.order_type == 'po') {
                url = window.route('po.search', {searchTerm: search});
            }
            return axios.get(url,  {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){

                    } else {
                        vm.orders = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    },
    watch: {
        'form.assign_admins': {
            handler: function (after, before) {
                this.form.assign_ids = [];
                if(after) {
                    after.forEach((x) => {
                        this.form.assign_ids.push(x.id);
                    })
                }
            },
            deep: true
        },
        'form.order_type': {
            handler: function (after, before) {
                this.orders = [];
                this.form.order_id = null;
                this.form.order = null;
            },
            deep: true
        },
    }
}
</script>

<style scoped>

</style>
